import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { State } from '../../models/state/state-model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class StateService {

  private serviceName = 'api/state';
  constructor(private http: Http,
    private cookieService: CookieService) {

  }

  getStates() {
    return this.http.get(`${this.serviceName}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addState(stateModel: State) {

    return this.http
      .post(`${this.serviceName}/InsertState`, stateModel, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  updateState(stateModel: State) {
    return this.http.post(`${this.serviceName}/UpdateState`, stateModel, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteState(id: string) {
    return this.http.get(`${this.serviceName}/DeleteState?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getState(stateId: string) {
    return this.http.get(`${this.serviceName}/GetStateById?id=` + stateId, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getStateByCountryId(id: string) {
    return this.http.get(`${this.serviceName}/GetStateByCountryId?countryId=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
  //this code for dependend country state and city
GetCitesByState(id: number) {
  return this.http.get(`${this.serviceName}/GetCitesByState?stateId=` + id, {
    headers: new Headers({
      "Token": this.cookieService.get('Login')
    })
  })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/state/state.service.ts